import { jsx as _jsx } from "react/jsx-runtime";
const smallS = { width: '426', height: '236' };
const mediumS = { width: '462', height: '256' };
export default function VideoComponent({ srcVideo, size = 'medium' }) {
    const sizeVideo = size === 'small' ? smallS : mediumS;
    const isMobile = window.innerWidth <= 320;
    const containerStyle = isMobile ? { paddingLeft: '17px', paddingRight: '17px' } : {};
    return (_jsx("div", Object.assign({ style: containerStyle }, { children: _jsx("iframe", Object.assign({}, sizeVideo, { src: srcVideo, title: "YouTube video player", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, style: { width: '100%', height: 'auto', position: 'relative', top: 'auto', left: 'auto', borderRadius: '13px' } })) })));
}
